import angular from 'angular'

import exth from '../utils/exth'

import { getElmStr } from '../utils/get-elm-str'
import { isNotEmpty } from '../utils/bits'
import { removeChildrenExcept } from '../utils/remove-children'

import { OVERLAY_CLASS, BOOTSTRAPPED_ATTR } from '../utils/shared-constants'

const QS_OVERLAY = `.${OVERLAY_CLASS}`
const NG_NON_BINDABLE = 'ng-non-bindable'

export default function ggsBootstrap(rootElm) {
  if (window.getComputedStyle(document.body) === null) {
    return Promise.reject(new Error('ggs-script cannot bootstrap a gallery inside of the hidden iframe! https://bugzilla.mozilla.org/show_bug.cgi?id=548397'))
  }

  const $rootElm = angular.element(rootElm)
  if (isNotEmpty($rootElm.attr(BOOTSTRAPPED_ATTR))) {
    return Promise.resolve()
  }

  $rootElm.attr(BOOTSTRAPPED_ATTR, 'preload-extensions')
  return exth.preloadExtensions($rootElm).then(() => {
    removeChildrenExcept($rootElm, QS_OVERLAY)

    $rootElm
      .prepend('<ggs-root></ggs-root>')
      .attr(BOOTSTRAPPED_ATTR, 'init-application')
    angular
      .bootstrap($rootElm, ['ggs'], { strictDi: true })
    $rootElm
      .addClass(NG_NON_BINDABLE)
      .attr(NG_NON_BINDABLE, 'true')
      .attr(BOOTSTRAPPED_ATTR, 'true')

    console.info(`gallery is bootstrapped! simply detach the element to completely destroy the gallery! ${getElmStr($rootElm)}`)
    return $rootElm
  })
}
